import {
  SECTION,
  CAROUSEL,
  MENU,
  ASSET,
  PAGE,
  CONTENT,
  GROUP,
} from "constants/widgetTypes";
import { useSelectedWidgetSelector } from "./useEditorSession";
import {
  hasContentAboveOrBelowSelection,
  isSelectionIndependentHorizontally,
} from "../helper/layoutManager";
import { useSelector } from "react-redux";
import _ from "lodash";
import { SEGMENT_STORYBOARDS } from "constants/storyboardType";

const CONTAINER_TYPES = [
  SECTION,
  MENU,
  ASSET,
  CONTENT,
  GROUP,
  CAROUSEL
];

export const useMakeFrame = ({ editorSession }) => {
  const selectedWidgets = useSelectedWidgetSelector(editorSession);
  const widgets = useSelector((state) => _.get(state, `${editorSession}.present.widgets`, []));
  const storyboardType = useSelector(state => _.get(state, "storyboards.storyboard.item.type", null));
  const entityType = useSelector((state) =>
    _.get(state, `${editorSession}.present.entityType`),
  );
  let checkParentConnection = true;

  if (
    !SEGMENT_STORYBOARDS.includes(storyboardType) ||
    entityType === "GATING" ||
    selectedWidgets.length === 0 ||
    (selectedWidgets?.[0]?.type === CAROUSEL && _.get(selectedWidgets?.[0], 'properties.desktop.free'))
  ) {
    return { makeFrameShow: false, makeFramePageId: null };
  }

  if(selectedWidgets.length === 1 && !CONTAINER_TYPES.includes(selectedWidgets[0].type)) {
    return { makeFrameShow: false, makeFramePageId: null };
  }

  /** PAGE CHECK */
  const pageIds = selectedWidgets.map((w) => getPageAncestor(widgets, w));
  const allSamePage =
    pageIds.every((id) => id === pageIds[0]) && pageIds[0] != null;
  if (!allSamePage) return { makeFrameShow: false, makeFramePageId: null };

  /** HORIZONTAL POSITION CHECK */
  const pageId = pageIds[0];
  const selectedIds = selectedWidgets.map(w => w.uid)

  if(CONTAINER_TYPES.includes(selectedWidgets[0].type)) {
    checkParentConnection = false;
  }

  if (
    !isSelectionIndependentHorizontally(
      editorSession,
      pageId,
      selectedIds,
      widgets,
      checkParentConnection
    )
  ) {
    return { makeFrameShow: false, makeFramePageId: null };
  }

  /** CONTENT CHECK */
  if (
    !hasContentAboveOrBelowSelection(
      editorSession,
      pageId,
      selectedIds,
      widgets,
      checkParentConnection
    )
  ) {
    return { makeFrameShow: false, makeFramePageId: null };
  }

  return { makeFrameShow: true, makeFramePageId: pageId };
};

function getPageAncestor(widgets, widget) {
  let w = widget;
  while (w && w.parent) {
    const parent = widgets.find(item => item.uid === w.parent);
    if (!parent) return null;
    if (parent.type === PAGE) return parent.uid;
    w = parent;
  }
  return null;
}